import type { Operand } from 'api/schemas/operand';

export const getOperandValue = <T extends object>(operand: Operand, composition?: T | null): number | null => {
  if (!composition) {
    return null;
  }

  const value = composition[operand as keyof T];

  return typeof value === 'number' ? value : null;
};
